import { render, staticRenderFns } from "./envelopeChats.vue?vue&type=template&id=3ed94182&scoped=true"
import script from "./envelopeChats.vue?vue&type=script&lang=js"
export * from "./envelopeChats.vue?vue&type=script&lang=js"
import style0 from "./envelopeChats.vue?vue&type=style&index=0&id=3ed94182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed94182",
  null
  
)

export default component.exports